import { map, takeWhile, timer } from 'rxjs';

/**
 * Funcion que devuelve una cuenta regresiva envuelta en un @Observable
 * @param minutes Tiempo en minutos que va a durar la cuentra regresiva
 * @returns Un objeto con la informacion relavante respecto a la cuenta regresiva,
 * como los minutos y segundos, si se ha terminado la cuenta regresiva y valores en formato texto.
 * (Por ahora no muestra horas, solo minutos y segundos)
 */
export const countdown = (minutes: number, startAt = 60) => {
  /** @type {number} Intervalo de tiempo de las emisiones (1s) */
  const k = 1000;
  /** @type {number} Sedundos que dura la cuenta regresiva*/
  const time = minutes * startAt;

  return timer(0, k).pipe(
    map((s) => time - s),
    takeWhile((s) => s >= 0),
    map((seconds) => {
      const m = Math.trunc(seconds / 60);
      const s = seconds - m * 60;

      return {
        m: m < 10 ? `0${m}` : `${m}`,
        s: s < 10 ? `0${s}` : `${s}`,
        minutes: m,
        seconds,
        finished: seconds === 0,
      };
    })
  );
};

/**
 *Representa una cuenta regresiva
 *
 * @export
 * @interface Countdown
 */
export interface Countdown {
  /**
   *Minutos en formato texto
   *
   * @type {string}
   * @memberof Countdown
   */
  m: string;

  /**
   *Segundos en formato texto
   *
   * @type {string}
   * @memberof Countdown
   */
  s: string;

  /**
   *Munutos
   *
   * @type {number}
   * @memberof Countdown
   */
  minutes: number;

  /**
   *Segundos
   *
   * @type {number}
   * @memberof Countdown
   */
  seconds: number;

  /**
   *Indica si la cuenta regresiva ha terminado
   *
   * @type {boolean}
   * @memberof Countdown
   */
  finished: boolean;
}
